module.exports = __webpack_public_path__ + "static/media/graficoDrDiabetes.43b0c78b.png";